import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import FormSuccess from "../../Components/SharedComponent/FormSuccess/FormSuccess";
import "../../Components/SharedComponent/FormSuccess/FormSuccess.scss";
import SalesService from "../../Services/SalesService";
import { OverlayLoader } from "../../Components/Loader/Loader";
/**
 * UserProjects Component displays a list of projects assigned to user.
 *
 * @component
 */
const FormSuccessPage = () => {
  const { id: formId } = useParams();
  const [formData, setFormData] = useState(null);
  const [parsedData, setParsedFormData] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchFormData = async () => {
      setLoading(true);
      try {
        const response = await SalesService.fetchSale(formId);
        const form = response.data.data[0] ?? null;
        setFormData(form);

        const parsedFormData = form?.form_data
          ? JSON.parse(form.form_data)
          : null;
        setParsedFormData(parsedFormData);
      } catch (error) {
        console.error("Error fetching form data:", error);
        setFormData(null);
        setParsedFormData(null);
      } finally {
        setLoading(false);
      }
    };

    if (formId) {
      fetchFormData();
    } else {
      setLoading(false);
    }
  }, [formId]);

  useEffect(() => {
    if (!loading && !formData) {
      navigate("/not-found", { replace: true });
    }
  }, [formData, loading, navigate]);

  return (
    <React.Fragment>
      <div className="form_Success_page_container">
        <div className="form_Success_wrap">
          <FormSuccess
            parsedData={parsedData}
            formData={formData}
            formId={formId}
          />
        </div>
      </div>
      {loading && <OverlayLoader />}
    </React.Fragment>
  );
};

export default FormSuccessPage;
